//React imports
import React, { createRef, Fragment, useEffect } from 'react';

//Layout Component
import SettingsLayout from '../../../containers/SettingsLayout';

//Material UI Components
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import DeleteIcon from '@material-ui/icons/Close';
import PlusIcon from '@material-ui/icons/Add';

//Accordion Components
import Interests from './EditProfile/Interests';
import Virtues from './EditProfile/Virtues';
import ProfilePrompts from './EditProfile/ProfilePrompts';
import Bio from './EditProfile/Bio';

//Redux
import { useSelector, useDispatch } from 'react-redux';
import * as actions from '../../../store/actions/profileActions';

//Styles
import '../../../assets/css/settings.css';

const useStyles = makeStyles((theme) => ({
    root: {
        // '&:hover': {
        //     backgroundColor: '#41004C',
        //     color: '#FFF'
        // },
        '&:before': {
            display: 'none'
        },
        '&:active': {
            backgroundColor: 'rgba(239,239,239,0.4)',
        },
        backgroundColor: 'transparent',
        cursor: 'pointer',
        fontFamily: 'Ubuntu, sansSerif',
        color: '#41004C',
        fontSize: '1.15rem',
        fontWeight: 600,
        width: '100%',
        textAlign: 'left',
        border: 'none',
        outline: 'none'
    },
    'MuiAccordionDetails-root': {
        display: 'block',
        backgroundColor: 'rgba(239,239,239,0.4)',
        padding: '10px',
        borderRadius: '30px'
    },
    'Mui-expanded': {
        backgroundColor: 'rgba(239,239,239,0.4)',
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightBold,
    },
  }
));

const EditProfile = () => {
    const classes = useStyles();
    const profileState = useSelector(state => state.profile);
    const dispatch = useDispatch();
    
    const handleChange = (newValue) => {
        const reader = new FileReader();
        if (newValue.photoUrl) {
            reader.readAsDataURL(newValue.photoUrl);
            reader.onload = () => {
                var base64 = reader.result;
                var new64Value = {...newValue, photoUrl: base64, profileId: profileState.userProfile.profileId};
                dispatch(actions.addProfilePhoto(new64Value));
            };
            reader.onerror = (error) => {
                console.error(error);
            }
        }
    }

    const renderImageViewer = () => {
        if (profileState.profile.profilePhotos.length === 2) {
            return (
                <div className="pic-wrapper">
                    <input onChange={(e) => handleChange({ photoUrl: e.target.files[0], timeAdded: new Date().toISOString() })} type="file" name="file" id="file1" className="profile-pic-upload" />
                    <label htmlFor="file1" className="input-label"><i className="fa fa-plus"></i></label>
                </div>
            );
        }
        else if (profileState.profile.profilePhotos.length === 1) {
            return (
                <Fragment>
                    <div className="pic-wrapper">
                        <input onChange={(e) => handleChange({ photoUrl: e.target.files[0], timeAdded: new Date().toISOString() })} type="file" name="file" id="file1" className="profile-pic-upload" />
                        <label htmlFor="file1" className="input-label"><i className="fa fa-plus"></i></label>
                    </div>
                    <div className="pic-wrapper">
                        <input onChange={(e) => handleChange({ photoUrl: e.target.files[0], timeAdded: new Date().toISOString() })} type="file" name="file" id="file2" className="profile-pic-upload" />
                        <label htmlFor="file2" className="input-label"><i className="fa fa-plus"></i></label>
                    </div>
                </Fragment>
            );
        }
        else if (profileState.profile.profilePhotos.length === 0) {
            return (
                <Fragment>
                    <div className="pic-wrapper">
                        <input onChange={(e) => handleChange({ photoUrl: e.target.files[0], timeAdded: new Date().toISOString() })} type="file" name="file1" id="file1" className="profile-pic-upload" />
                        <label htmlFor="file1" className="input-label"><i className="fa fa-plus"></i></label>
                    </div>
                    <div className="pic-wrapper">
                        <input onChange={(e) => handleChange({ photoUrl: e.target.files[0], timeAdded: new Date().toISOString() })} type="file" name="file2" id="file2" className="profile-pic-upload" />
                        <label htmlFor="file2" className="input-label"><i className="fa fa-plus"></i></label>
                    </div>
                    <div className="pic-wrapper">
                        <input onChange={(e) => handleChange({ photoUrl: e.target.files[0], timeAdded: new Date().toISOString() })} type="file" name="file3" id="file3" className="profile-pic-upload" />
                        <label htmlFor="file3" className="input-label"><i className="fa fa-plus"></i></label>
                    </div>
                </Fragment>
            );
        }
    }

    const removeImage = id => {
        dispatch(actions.removeProfilePhoto(id));
    }
    
    useEffect(() => {
        dispatch(actions.collectProfileData(profileState.userProfile));
    }, [profileState.userProfile]);

    return (
        <SettingsLayout>
            <div className="content-row">
                <div className="content-title">
                    <h1>Dating Profile</h1>
                </div>

                <div className="content-blocks">
                    <div className="DateProfile-block">
                        <div className="DateProfile-form">
                            <div>Profile images</div>                                
                            <div className="profile-pic-grp">
                                {profileState.profile.profilePhotos.length !== 0 ?
                                    profileState.profile.profilePhotos.map((photo,index) => {
                                        return (
                                            <div key={index} className="pic-container">
                                                <img src={photo.photoUrl} alt="profile photo" className="pic-wrapper"/>
                                                <button className="pic-wrapper-btn" onClick={() => removeImage(photo.profilePhotoId)}>
                                                    <DeleteIcon htmlColor="#666666" />
                                                </button>
                                            </div>
                                        )
                                    }) : null}
                                {renderImageViewer()}
                            </div>
                            <div className="profile-info-block">
                                <button className="preview-button">
                                    <p>Preview Profile</p>
                                    <i className="fa fa-angle-right"></i>
                                </button>

                                <br />
                                <Accordion elevation={0} className={classes.root}>
                                    <AccordionSummary
                                        expandIcon={<PlusIcon />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header">
                                        <Typography className={classes.heading}>Bio</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails className={classes['MuiAccordionDetails-root']}>
                                        <Bio bio={profileState.profile.bio} />
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion elevation={0} className={classes.root}>
                                    <AccordionSummary
                                        expandIcon={<PlusIcon />}
                                        aria-controls="panel2a-content"
                                        id="panel2a-header">
                                        <Typography className={classes.heading}>Virtues</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails className={classes['MuiAccordionDetails-root']}>
                                        <Virtues virtues={profileState.profile.virtue} />
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion elevation={0} className={classes.root}>
                                    <AccordionSummary
                                        expandIcon={<PlusIcon />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header">
                                        <Typography className={classes.heading}>Interests</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails className={classes['MuiAccordionDetails-root']}>
                                        <Interests />
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion elevation={0} className={classes.root}>
                                    <AccordionSummary
                                        expandIcon={<PlusIcon />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header">
                                        <Typography className={classes.heading}>Profile Prompts</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails className={classes['MuiAccordionDetails-root']} style={{backgroundColor: 'transparent'}}>
                                        <ProfilePrompts prompts={profileState.profile.profilePrompts} />
                                    </AccordionDetails>
                                </Accordion>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </SettingsLayout>
    )
}

export default EditProfile;
